import React from 'react';

const ML_Learning = () => {
    return (
        <div>ML_Learning Component</div>
    );
}

export default ML_Learning;
